import { createSelector } from 'reselect';
import { countrySelector } from '@xarvio/frontend-core-state/lib/intl/selectors';
import {
  defaultFeaturesSelector,
  regionalFeaturesSelector,
  tokenFeaturesSelector,
  qaFeaturesSelector,
} from '../../../redux/modules/featureFlags/selectors';

export const mapStateToProps = createSelector(
  defaultFeaturesSelector,
  regionalFeaturesSelector,
  tokenFeaturesSelector,
  qaFeaturesSelector,
  countrySelector,
  (
    defaultFeatures,
    regionalFeatures,
    tokenFeatures,
    qaFeatures,
    countryCode,
  ) => {
    return {
      defaultFeatures,
      regionalFeatures,
      tokenFeatures,
      qaFeatures,
      countryCode,
    };
  },
);
